import React from 'react';
import { Tooltip, IconButton, Box } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

interface GlossarioTooltipProps {
  termo: string;
  definicao: string;
  onClick?: () => void;
}

/**
 * Tooltip inline para termos do glossário
 * 
 * @example
 * ```tsx
 * <GlossarioTooltip 
 *   termo="WACC" 
 *   definicao="Weighted Average Cost of Capital"
 *   onClick={() => abrirGlossario('WACC')}
 * />
 * ```
 */
export const GlossarioTooltip: React.FC<GlossarioTooltipProps> = ({
  termo,
  definicao,
  onClick,
}) => {
  return (
    <Tooltip 
      title={
        <Box>
          <strong>{termo}</strong>
          <br />
          {definicao}
        </Box>
      }
      arrow
    >
      <IconButton 
        size="small" 
        onClick={onClick}
        sx={{ 
          ml: 0.5,
          p: 0.5,
          '&:hover': {
            backgroundColor: 'primary.light',
            color: 'primary.contrastText',
          },
        }}
      >
        <HelpOutlineIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};
